/**
 * Единый каталог интересов для API (синхронизация в БД), сида и фолбэка веб-клиента.
 * Первые 8 позиций (индексы 0–7) совпадают со старым фолбэком API по slug — для совместимости POST /profile/interests с «синтетическими» id 1–8.
 */
export type InterestCatalogEntry = {
  slug: string
  title: string
  emoji: string
}

export const INTERESTS_CATALOG_ENTRIES: ReadonlyArray<InterestCatalogEntry> = [
  { slug: 'travel', title: 'Путешествия', emoji: '✈️' },
  { slug: 'music', title: 'Музыка', emoji: '🎵' },
  { slug: 'cinema', title: 'Кино', emoji: '🎬' },
  { slug: 'books', title: 'Книги', emoji: '📚' },
  { slug: 'sports', title: 'Спорт', emoji: '⚽' },
  { slug: 'fitness', title: 'Фитнес', emoji: '💪' },
  { slug: 'food', title: 'Кулинария', emoji: '🍳' },
  { slug: 'art', title: 'Искусство', emoji: '🎨' },
  { slug: 'photography', title: 'Фотография', emoji: '📷' },
  { slug: 'gaming', title: 'Видеоигры', emoji: '🎮' },
  { slug: 'dancing', title: 'Танцы', emoji: '💃' },
  { slug: 'yoga', title: 'Йога', emoji: '🧘' },
  { slug: 'running', title: 'Бег', emoji: '🏃' },
  { slug: 'cycling', title: 'Велоспорт', emoji: '🚴' },
  { slug: 'hiking', title: 'Походы', emoji: '🥾' },
  { slug: 'camping', title: 'Кемпинг', emoji: '⛺' },
  { slug: 'sea-beach', title: 'Море и пляж', emoji: '🏖️' },
  { slug: 'skiing', title: 'Лыжи и сноуборд', emoji: '⛷️' },
  { slug: 'pets', title: 'Домашние животные', emoji: '🐾' },
  { slug: 'volunteering', title: 'Волонтёрство', emoji: '🤝' },
  { slug: 'it-tech', title: 'IT и технологии', emoji: '💻' },
  { slug: 'science', title: 'Наука', emoji: '🔬' },
  { slug: 'psychology', title: 'Психология', emoji: '🧠' },
  { slug: 'board-games', title: 'Настольные игры', emoji: '🎲' },
  { slug: 'podcasts', title: 'Подкасты', emoji: '🎧' },
  { slug: 'concerts', title: 'Концерты', emoji: '🎤' },
  { slug: 'theater', title: 'Театр', emoji: '🎭' },
  { slug: 'museums', title: 'Музеи', emoji: '🏛️' },
  { slug: 'architecture', title: 'Архитектура', emoji: '🏙️' },
  { slug: 'fashion', title: 'Мода', emoji: '👗' },
  { slug: 'gardening', title: 'Сад и огород', emoji: '🌱' },
  { slug: 'cars', title: 'Автомобили', emoji: '🚗' },
  { slug: 'motorcycles', title: 'Мотоциклы', emoji: '🏍️' },
  { slug: 'investing', title: 'Инвестиции', emoji: '📈' },
  { slug: 'meditation', title: 'Медитация', emoji: '🕉️' },
  { slug: 'self-development', title: 'Саморазвитие', emoji: '🌟' },
  { slug: 'languages', title: 'Иностранные языки', emoji: '🌍' },
  { slug: 'drawing', title: 'Рисование', emoji: '✏️' },
  { slug: 'design', title: 'Дизайн', emoji: '🖌️' },
  { slug: 'blogging', title: 'Блоги и соцсети', emoji: '📱' },
  { slug: 'wine', title: 'Вино', emoji: '🍷' },
  { slug: 'coffee', title: 'Кофе', emoji: '☕' },
  { slug: 'tea', title: 'Чай', emoji: '🍵' },
  { slug: 'fishing', title: 'Рыбалка', emoji: '🎣' },
  { slug: 'nature', title: 'Природа и птицы', emoji: '🦅' },
  { slug: 'chess', title: 'Шахматы', emoji: '♟️' },
  { slug: 'esports', title: 'Киберспорт', emoji: '🏆' },
  { slug: 'family-kids', title: 'Семья и дети', emoji: '👶' },
  { slug: 'home-cozy', title: 'Дом и уют', emoji: '🛋️' },
  { slug: 'crafts', title: 'Рукоделие', emoji: '🧵' },
  { slug: 'anime', title: 'Аниме и манга', emoji: '🇯🇵' },
  { slug: 'kpop', title: 'K-pop', emoji: '🇰🇷' },
  { slug: 'nightlife', title: 'Ночная жизнь', emoji: '🌃' },
  { slug: 'pubs', title: 'Бары и пабы', emoji: '🍺' },
  { slug: 'vegan', title: 'Веганство', emoji: '🥗' },
  { slug: 'astrology', title: 'Астрология', emoji: '✨' },
  { slug: 'crypto', title: 'Криптовалюты', emoji: '₿' },
  { slug: 'startups', title: 'Стартапы', emoji: '🚀' },
  { slug: 'cooking', title: 'Рестораны и гастрономия', emoji: '👨‍🍳' },
]

/** Для офлайн/ошибки API: те же slug, id 1…N как в старом фолбэке. */
export function interestsCatalogAsClientRows(): Array<{
  id: number
  slug: string
  title: string
  emoji: string
}> {
  return INTERESTS_CATALOG_ENTRIES.map((row, i) => ({
    id: i + 1,
    ...row,
  }))
}
